"use client"
import { useState } from "react";

import { HeroUIProvider } from "@heroui/react";

import Nav from "@/app/navbar";
import Intro from "@/app/frames/intro";

export default function Hero() {
    const [inView, setInView] = useState<boolean | null>(null)
    return (
        <HeroUIProvider>
            <div className="z-50" style={{ width: '100%', height: '100%', position: 'relative' }}>
                <Nav inView={inView} />
            </div>
            <section id="home" className="pb-48 z-40" style={{ width: '100%', height: '100%', position: "relative" }} >
                <Intro setInView={setInView} />
            </section>
        </HeroUIProvider>
    )
}